import React, { useRef, useEffect, useState } from 'react';
import classnames from 'classnames/bind';
import localesReplacement from '../../../utils/localesReplacement';
import {Swiper, SwiperSlide} from 'swiper/react';
import {Pagination, Navigation, Autoplay} from 'swiper/modules';
import {
  IBreadCrumb,
  ICountry,
  IProd,
  IState,
  Replacement,
} from '../../../interface';
import publicImage from '../../../utils/publicImage';
import { Variant, Theme } from '../../../constants/variants';
import {
  HEADER_CAROUSEL_PRODUCT_ENABLED,
  HEADER_CAROUSEL_PRODUCT_ID
} from '../../../constants';
import { getProduct } from '../../../services';
import {connect} from 'react-redux';
import {useSearchParams} from 'react-router-dom';
import {useMediaQuery} from 'react-responsive';
import Breadcrumb from '../Breadcrumb';
import style from './index.module.scss';
import FordBrand from '../Brands/Ford';

import CountrySelector from '../CountrySelector';

const cx = classnames.bind(style);

interface Props {
  mode: boolean;
  replacements: Replacement;
  country: ICountry;
  product?: IProd;
}

const castrolBannersRetail: any[] = [
  {
    link: publicImage('hero_image.png'),
    title: 'Find the right Castrol products',
    description: 'Get the right Castrol® fluid or oil for your vehicle or equipment.'
  }
];

const castrolBannersTrade: any[] = [
  {
    ...castrolBannersRetail.at(0),
    link: publicImage('hero_image-trade.png')
  }
];

const fordBannersLight: any[] = [
  {
    ...castrolBannersRetail.at(0),
    link: publicImage('ford-banner-light.png'),
  }
]

const fordBannersDark: any[] = [
  {
    ...fordBannersLight.at(0),
    link: publicImage('ford-banner-dark.png')
  }
];

// eslint-disable-next-line sonarjs/cognitive-complexity
function HeaderTemplate(props: Props) {
  const {mode, replacements, country, product} = props;
  const isDesktopOrLaptop = useMediaQuery({minWidth: 1024});
  const [params] = useSearchParams();
  const page = params.get('page');
  let pageName: string;
  let breadcrumb: IBreadCrumb[];
  let title: string;

  const variant = params.get('variant');
  const isFord = variant === Variant.FORD;
  const isDark = params.get('theme') === Theme.dark;

  const [ data, setData ] = useState<any[]>([]);

  const setDefaultBanner = () => {
    if (isFord) {
      setData(isDark ? fordBannersDark : fordBannersLight);
    }
    else {
      setData(mode ? castrolBannersTrade : castrolBannersRetail);
    }
  };

  useEffect(() => {
    setDefaultBanner();
  }, [mode, params]);

  useEffect(() => {
    if (HEADER_CAROUSEL_PRODUCT_ENABLED) {
      getProduct(HEADER_CAROUSEL_PRODUCT_ID).then((data) => {
        if (data.status !== 200) {
          setDefaultBanner();
          return;
        }
        const response = (data.data as any).links.map((item: any) => {
          const parts = item.displayText.split('🚗');
          return {
            variant: parts.at(0),
            title: parts.at(1),
            description: parts.at(2),
            link: item.link
          };
        }).filter((item: any) => !variant || item.variant.toLowerCase().search(variant) >= 0);
        if (response.length > 0) {
          setData(response);
        }

      }).catch((_) => {
        setDefaultBanner();
      });
    }
  }, []);
  switch (page) {
  case 'wheretobuy':
    breadcrumb = [
      {
        value: 'Home',
        href: '/',
        static: true,
      },
      {
        value: 'Product Finder',
        href: '/',
        static: true,
      },
      {
        value: 'Where to Buy or Service',
        static: true,
      },
    ];
    pageName = 'wtb';
    title =
      country.isoCode === 'AUT'
      ? 'WHERE TO BUY OR SERVICE AUSTRIA'
      : 'WHERE TO BUY OR SERVICE';
    break;
  case 'recommendedProducts':
    breadcrumb = [
      {
        value: 'Home',
        href: '/',
        static: true,
      },
      {
        value: 'Product Finder',
        href: '-1',
        static: true,
      },
      {
        value: 'Recommended oils & LUBRICANTS',
        static: true,
      },
    ];
    pageName = 'recommended';
    title = 'RECOMMENDED OILS & LUBRICANTS';
    break;
  case 'product':
    breadcrumb = isDesktopOrLaptop
      ? [
        {
          value: 'Home',
          href: '/',
          static: true,
        },
        {
          value: 'Product Finder',
          href: '/',
          static: true,
        },
        {
          value: 'Recommended oils & LUBRICANTS',
          static: true,
        },
      ]
    : [
      {
        value: 'Home',
        href: '/',
        static: true,
      },
      {
        value: 'Product Finder',
        href: '/',
        static: true,
      },
      {
        value: 'RECOMMENDED OILS',
        href: '-1',
        static: true,
      },
      {
        value: product?.name ? product?.name : '',
      },
    ];
    pageName = 'product';
    title = isDesktopOrLaptop
      ? 'RECOMMENDED OILS & LUBRICANTS'
      : product?.name ?? '';
    break;
  default:
      breadcrumb = [
        {
          value: 'HOME',
          href: '#',
          static: true,
        },
        {
          value: 'Product Finder',       
          static: true,
        },      
      ];
    pageName = 'landing';
    title = 'Find the right Castrol products';
    break;
  }

  return (
    <div className={cx(pageName, 'header')}>
      <div>
        <Swiper
          loop={true}
          pagination={{
            clickable: true,
          }}
          modules={[Pagination, Navigation]}
          navigation={true}
          className={cx('slider')}
        >
          {
            /*<div className={cx('heading')}>
              <Breadcrumb dataList={breadcrumb} />
              </div>
            */
          }

          { data.map((item: any, i) => {
            return (
              <SwiperSlide key={item.title + i}>
                <div className={cx('item')}>
                  <img src={item.link} />
                  <div className={`${cx('mask')} ${isFord ? cx('mask-ford') : cx('mask')}`}>
                    <div className={isFord ? cx('mask-inner') : cx('mask-inner-castrol')}>
                      <div className={cx('breadcrumb-container')}>
                        <Breadcrumb dataList={breadcrumb} />
                      </div>
                      <strong>{localesReplacement(replacements, item.title)}</strong>
                      <p>
                        {localesReplacement(replacements, item.description)}
                      </p>
                    </div>
                    { isFord && (
                      <div className={cx('brands')}>
                        <FordBrand isDark={isDark} />
                      </div>
                    )}
                  </div>
                </div>
              </SwiperSlide>
            )
          })}
        </Swiper>
      </div>
      { isFord && (
        <div className={cx('country-selector')}>
          <CountrySelector replacements={replacements} />
        </div>
      )}
    </div>
  );
}

const mapStateToProps = (state: IState) => ({
  replacements: state.replacements,
  country: state.country,
});

export default connect(mapStateToProps)(HeaderTemplate);
